module.exports = __webpack_public_path__ + "img/avatar.95a7090a.png";